import * as React from "react";
import { withNamespaces, WithNamespaces } from "react-i18next";

const StorePage = (props: WithNamespaces) => (
  <div className="pt-4 store">
    <div className="container-fluid">
      <div className="row">
        <div className="col-12 col-md-12 col-lg-4">
          <div className="card">
            <div className="card-header">{props.t("store.help")}</div>
            <div className="card-body">
              <img src="assets/store-help.png" />
            </div>
            <div className="card-footer">
              <div className="container">
                <div className="row">
                  <div className="col-12 col-lg-6 col-md-6 col-sm-12 p-0">
                    <button className="btn border-right border-left">
                      <img src="/assets/svgs/infos.svg" />
                      <small>{props.t("store.buttons.moreInfo")}</small>
                    </button>
                  </div>
                  <div className="col-12 col-lg-6 col-md-6 col-sm-12 p-0">
                    <button className="btn border-right">
                      <img src="/assets/svgs/flag.svg" />
                      <small>{props.t("store.buttons.contact")}</small>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-12 col-lg-4">
          <div className="card">
            <div className="card-header">{props.t("store.model")}</div>
            <div className="card-body">
              <img src="assets/store-model.png" />
            </div>
            <div className="card-footer">
              <div className="container">
                <div className="row">
                  <div className="col-12 col-lg-6 col-md-6 col-sm-12 p-0">
                    <button className="btn border-right border-left">
                      <img src="/assets/svgs/infos.svg" />
                      <small>{props.t("store.buttons.moreInfo")}</small>
                    </button>
                  </div>
                  <div className="col-12 col-lg-6 col-md-6 col-sm-12 p-0">
                    <button className="btn border-right">
                      <img src="/assets/svgs/flag.svg" />
                      <small>{props.t("store.buttons.contact")}</small>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-12 col-lg-4">
          <div className="card last">
            <div className="card-header">{props.t("store.crm")}</div>
            <div className="card-body border-right border-left">
              <img src="assets/store-crm.png" />
            </div>
            <div className="card-footer">
              <div className="container">
                <div className="row">
                  <div className="col-12 col-lg-6 col-md-6 col-sm-12 p-0">
                    <button className="btn border-right border-left">
                      <img src="/assets/svgs/infos.svg" />
                      <small>{props.t("store.buttons.moreInfo")}</small>
                    </button>
                  </div>
                  <div className="col-12 col-lg-6 col-md-6 col-sm-12 p-0">
                    <button className="btn  border-right">
                      <img src="/assets/svgs/flag.svg" />
                      <small>{props.t("store.buttons.contact")}</small>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);
export default withNamespaces()(StorePage);



// WEBPACK FOOTER //
// ./src/components/Store.tsx